import { autorun, observable, action } from 'mobx';
import debounce from 'lodash/debounce';

import compute from 'lib/mobx/compute';
import withCompute from 'lib/mobx/with-compute';

import { UserStore } from 'four-nets/user/user';

export { UsersSearch };

@withCompute()
class UsersSearch {
    userStore: UserStore;

    @observable users;
    @observable loading = false;
    @compute value: string;

    promise;

    constructor(options) {
        const { userStore } = options;

        this.userStore = userStore;
        autorun(this.observeValue);
    }

    @action searchDidSuceed = users => {
        this.users = users;
    };

    searchDidFail = err => {
        console.error(err);
    };

    searchDidFinish = () => {
        this.loading = false;
    };

    searchUsers = debounce(options => {
        const { username } = options;

        this.promise = this.userStore
            .search({
                username,
            })
            .then(this.searchDidSuceed)
            .catch(this.searchDidFail)
            .finally(this.searchDidFinish);
    }, 300);

    observeValue = () => {
        this.loading = false;

        if (this.promise) {
            this.promise.cancel();
        }

        if (this.value && this.value.length > 2) {
            this.loading = true;
            this.searchUsers({
                username: this.value,
            });
        } else {
            this.users = null;
        }
    };
}
